import { Spin } from "antd";
import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { usePutV2PersonsByPersonIdNotificationsTokenMutation } from "app/apiRTK";
// import { deleteCurrentToken } from "app/firebase";
import { useAppDispatch, useAppSelector } from "app/hooks";

import {
  authPersonState,
  authStatusState,
  setGuestStatus,
} from "storeSlices/login";

const Logout = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const status = useAppSelector(authStatusState);
  const authPerson = useAppSelector(authPersonState);

  // useMutation
  const [changePersonToken] =
    usePutV2PersonsByPersonIdNotificationsTokenMutation();

  const firstEntry = sessionStorage.getItem("firstEntry");

  useEffect(() => {
    // deleteCurrentToken();

    const performLogout = async () => {
      try {
        if (authPerson && authPerson.notificationToken) {
          await changePersonToken({
            personId: authPerson.id,
            notificationToken: undefined,
          }).unwrap();
        }
      } catch (error) {
        // Игнорируем ошибки при логауте (например, токен уже невалиден)
        console.warn("Ошибка при очистке notification token:", error);
      } finally {
        // Всегда устанавливаем статус гостя, даже если запрос не удался
        dispatch(setGuestStatus());
      }
    };

    performLogout();
  }, [authPerson, changePersonToken, dispatch]);

  if (firstEntry) {
    sessionStorage.removeItem("firstEntry");
  }

  if (status === "guest") {
    return <Navigate to="/login" state={location.state} />;
  } else {
    return <Spin size="large" />;
  }
};

export default Logout;
